import { ThemeUICSSObject } from 'theme-ui';
import labelBox from './labelBox';

export const boxes: ThemeUICSSObject = {
  labelBox,
  /* PREPEND HERE */
};
